import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { LogoMarquee } from '../components/LogoMarquee';
import { TimelineSection } from '../components/TimelineSection';
import { OutcomeSection } from '../components/OutcomeSection';
import { ApproachSection } from '../components/ApproachSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { OngoingSection } from '../components/OngoingSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-background" data-id="element-259">
      <Nav data-id="element-260" />
      <main data-id="element-261">
        <Hero data-id="element-262" />
        <LogoMarquee data-id="element-263" />
        <TimelineSection data-id="element-264" />
        <OutcomeSection data-id="element-265" />
        <ApproachSection data-id="element-266" />
        <DeliverablesSection data-id="element-267" />
        <OngoingSection data-id="element-268" />
        <CTASection data-id="element-269" />
      </main>
      <Footer data-id="element-270" />
    </div>;
}